export default __webpack_public_path__ + "static/header.morf-2923a75e83c5bfd7a5823a8d91aae162.webp";